import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-down",
  "use": "icon-chevron-down-usage",
  "viewBox": "0 0 11 7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 7\" id=\"icon-chevron-down\"><path d=\"M11 1.4L5.5 7 0 1.4 1.4 0l4.1 4.1L9.6 0 11 1.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol